import React from "react";
import { Box, Button, Stack, Typography, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

const ActionButtons = ({
  loading,
  scheduleId,
  onCancel,
  onSave,
  isViewMode = false,
}) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" spacing={2} justifyContent="center">
      <Button
        variant="outlined"
        onClick={onCancel}
        sx={{
          width: 120,
          fontSize: "20px",
          color: "#1F242E",
          height: "55px",
          borderRadius: "8px",
          textTransform: "none",
          padding: "8px 24px",
          background: "#F2F2F3",
          border: "1px solid #414958",
          fontWeight: 600,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        disabled={loading}
      >
        <Typography
          component="span"
          style={{
            fontWeight: 600,
            fontSize: "20px",
          }}
        >
          {t("Cancel")}
        </Typography>
      </Button>
      {!isViewMode && (
        <Button
          type="submit"
          disabled={loading}
          onClick={onSave}
          sx={{
            width: 120,
            height: "55px",
            fontSize: "20px",
            color: "#1F242E",
            textTransform: "none",
            borderRadius: "8px",
            padding: "8px 24px",
            background: "#F9E719",
            border: "1px solid #414958",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "&:hover": {
              backgroundColor: "#F9E719",
            },
          }}
        >
          <Box
            component="span"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              lineHeight: 1,
            }}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : null}
            <Typography
              component="span"
              sx={{
                fontWeight: 600,
                fontSize: "20px",
                lineHeight: 1,
              }}
            >
              {scheduleId ? t("Update") : t("Save")}
            </Typography>
          </Box>
        </Button>
      )}
      
    </Stack>
  );
};

export default ActionButtons;
